module.exports = __webpack_public_path__ + "loggout.png?25ead96e17f2422e2f9a6c3e09b7bed0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loggout.png
// module id = 745
// module chunks = 0